import {
    FETCH_COURSES_DATA, SET_COURSES_DATA, SET_COURSES_USER_DATA, CLEAR_COURSES_DATA, SET_COURSES_FAILURE_DATA,
    SET_ACTIVE_COURSE_DATA, CLEAR_ACTIVE_COURSE_DATA, SET_QUIZ_DATA, FETCH_QUIZ_DATA, TOGGLE_QUIZ_ACTIVATION, SET_GRADE_DATA
} from "../../ActionTypes/coursesVetActionTypes"

import { SET_QUERY_ADDED_ALERT, CLEAR_QUERY_ADDED_ALERT, SET_GENERIC_ERROR_ALERT } from "../../ActionTypes/alertsActionTypes"
import axios from "axios"

//Login 
export const gradeView = (id) => async dispatch => {


    try {
        dispatch({ type: SET_GRADE_DATA, payload: null })
        dispatch({ type: FETCH_QUIZ_DATA, payload: true })
        let reqObj = {
            "course_id": id
        }

        let url = process.env.REACT_APP_API_URL + `/vetcourses/grade_details/`




        let result = await axios.post(url, reqObj)

        if (result.data) {


            dispatch({ type: SET_GRADE_DATA, payload: result.data })
            dispatch({ type: FETCH_QUIZ_DATA, payload: false })






        }
        else {
            dispatch({ type: SET_GENERIC_ERROR_ALERT })

            dispatch({ type: FETCH_QUIZ_DATA, payload: false })

        }



    }
    catch (err) {
        dispatch({ type: FETCH_QUIZ_DATA, payload: false })
        dispatch({ type: SET_GENERIC_ERROR_ALERT })
    }
}

